import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from '../../component/button/button';
import Header from '../../component/header/header';
import CustomInput from '../../component/CustomInput/CustomInput';
import Select from 'react-select';
import { subjects } from '../Templates/demoData';
import CustomSelect from '../../component/customSelect/customSelect';

import {
  FiPaperclip,
  FiEdit,
  FiMenu,
  FiRefreshCcw,
  FiRefreshCw,
  FiFilePlus,
  FiSave,
  FiPenTool,
} from 'react-icons/fi';
import ViewModal from '../Modal/ViewModal';

type Question = {
  complexity: string;
  number: number;
};

type TabKey = 'Question' | 'Solution' | 'Answers';

interface QuestionData {
  id: number;
  title: string;
  topic: string;
  difficulty: 'Easy' | 'Medium' | 'Hard';
  content: Record<TabKey, string>;
}

const questionData: QuestionData[] = Array.from({ length: 10 }).map(
  (_, index) => ({
    id: index + 1,
    title: 'Complex Analysis',
    topic: 'Algebra',
    difficulty: ['Easy', 'Medium', 'Hard'][index % 3] as
      | 'Easy'
      | 'Medium'
      | 'Hard',

    content: {
      Question: `Question Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequatur praesentium placeat, eaque quos ducimus necessitatibus laudantium ipsam error cupiditate aperiam nesciunt inventore numquam corporis dolorem, fuga modi officiis nisi in. ${index + 1}.`,
      Solution: `Solution Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequatur praesentium placeat, eaque quos ducimus necessitatibus laudantium ipsam error cupiditate aperiam nesciunt inventore numquam corporis dolorem, fuga modi officiis nisi in. ${index + 1}.`,
      Answers: `Answer Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequatur praesentium placeat, eaque quos ducimus necessitatibus laudantium ipsam error cupiditate aperiam nesciunt inventore numquam corporis dolorem, fuga modi officiis nisi in. ${index + 1}.`,
    },
  })
);

export default function ExamPaper() {
  const navigate = useNavigate();
  const location = useLocation();
  const [preview, setPreview] = useState(false);
  const [editBtn, setEditBtn] = useState(false);

  const [isOpen, setIsOpen] = useState(false);

  const [activeTabs, setActiveTabs] = useState<Record<number, TabKey>>(
    questionData.reduce(
      (acc, q) => {
        acc[q.id] = 'Question';
        return acc;
      },
      {} as Record<number, TabKey>
    )
  );

  const handleTabChange = (id: number, tab: TabKey) => {
    setActiveTabs(prev => ({ ...prev, [id]: tab }));
  };

  const handleRegenerate = (id: number) => {
    alert('generate new quesiton');
  };

  const tabButtons: TabKey[] = ['Question', 'Solution', 'Answers'];

  const {
    subjectQuestions = {},
  }: { subjectQuestions?: { [subjectId: string]: Question[] } } =
    location.state || {};

  useEffect(() => {
    console.log('Received subjectQuestions:', subjectQuestions);
  }, [subjectQuestions]);

  const openSaveModal = (action: string) => {};

  const openPublishModal = (action: string) => {};

  const handleHeaderButtonClick = (action: string) => {
    switch (action) {
      case 'preview':
        setPreview(true);
        break;
      case 'save':
        setIsOpen(true);
        break;
      case 'edit':
        setPreview(false);
        break;
      case 'publish':
        alert('publish');
        break;
      default:
        setPreview(false);
    }
  };

  const extraButton = preview ? (
    <Button
      style={{ marginLeft: '5px' }}
      type="secondary"
      buttonType="button"
      onClick={() => {
        handleHeaderButtonClick('edit');
      }}
      icon={<FiPenTool />}
      text="Edit"
    />
  ) : null;

  const handleModalSave = () => {
    alert('modal save button click');
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const { name, value } = e.target;
  };

  const handleSubjectSelect = (selectedOptions: any) => {
    const selectedValues = selectedOptions.map((option: any) => option.value);
  };

  const publishButton = (
    <Button
      style={{ marginLeft: '10px' }}
      type="primary"
      onClick={() => handleHeaderButtonClick('publish')}
      icon={<FiPenTool />}
      text="Publish"
    />
  );

  return (
    <div className="content exams">
      <Header
        pageTitle="Exam Paper"
        buttonIcon={preview ? <FiSave /> : <FiFilePlus />}
        buttonText={`${preview ? 'Save' : 'Preview'}`}
        type={preview ? 'primary' : 'secondary'}
        para={
          <span>
            <p>Mathematics</p>
          </span>
        }
        onClick={() => {
          handleHeaderButtonClick(preview ? 'save' : 'preview');
        }}
        extraButton={extraButton}
        firstButton={publishButton}
        isVisiableFirstButton={true}
      />

      <div className="flex flex-col gap-6 mt-3 rounded bg-white w-[80%] shadow-[6px_0px_10px_-2px_rgba(0,0,0,0.1)]">
        <div className="flex flex-col p-6 gap-6">
          <h2 className="text-xl font-bold text-gray-800">Complex Analysis</h2>

          {questionData.map(q => (
            <div key={q.id} className="flex flex-col gap-8  p-8 bg-gray-50">
              <div className="flex justify-between items-center w-full">
                <div className="flex items-center gap-2">
                  <div className="flex items-center gap-2 px-2 py-1">
                    {!preview && <FiMenu className="text-gray-600" />}

                    <span className="font-bold text-gray-700">
                      {String(q.id).padStart(2, '0')}
                    </span>
                  </div>

                  {!preview ? (
                    <>
                      <button className="px-2 py-1 text-sm border rounded text-gray-800 font-semibold">
                        {q.topic}
                      </button>

                      <button
                        className={`px-2 py-1 text-sm rounded font-semibold ${
                          q.difficulty === 'Hard'
                            ? 'border border-red-500'
                            : q.difficulty === 'Medium'
                              ? 'border border-yellow-500'
                              : 'border border-green-500'
                        }`}
                      >
                        {q.difficulty}
                      </button>
                    </>
                  ) : (
                    <span className="text-gray-800 text-xs font-normal leading-[18px] font-['Inter']">
                      Topic / {q.difficulty}
                    </span>
                  )}
                </div>

                <div className="flex">
                  {/* Tab Buttons */}
                  <div className="flex bg-gray-200">
                    {!preview
                      ? tabButtons.map(tab => (
                          <button
                            key={tab}
                            className={`px-4 py-2 rounded font-medium text-sm flex items-center ${
                              activeTabs[q.id] === tab
                                ? 'bg-white border text-gray-800'
                                : 'bg-gray-200 text-gray-800 hover:bg-gray-300'
                            }`}
                            onClick={() => handleTabChange(q.id, tab)}
                          >
                            {tab}
                          </button>
                        ))
                      : ''}
                  </div>

                  {!preview && (
                    <button
                      className="border px-4 py-2 rounded font-medium text-sm flex items-center ml-3"
                      onClick={() => handleRegenerate(q.id)}
                    >
                      <FiRefreshCcw className="mr-2" size={18} />
                      Regenerate
                    </button>
                  )}
                </div>
              </div>

              {/* Tab content */}
              <div className="flex flex-col gap-1 w-full pt-4">
                <p className="text-gray-700 text-base">
                  {q.content[activeTabs[q.id]]}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <ViewModal
        title="Save Exam Paper"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        width="684px"
        extraBtn={true}
        extraBtnName="Save"
        extraBtnType="secondary"
        handleExtraButtonClick={handleModalSave}
        body={
          <div>
            <h3 className="text-2xl font-semibold text-left mb-1 py-6 gap-6">
              Name this Exam Paper
            </h3>
            <div className="mb-6 flex">
              <div className="w-1/2 gap-8 pr-5">
                <label className="text-[#344054] font-['Plus_Jakarta_Sans'] text-sm font-medium leading-5">
                  Name this Exam Paper
                </label>
                <CustomInput
                  placeholder="Subject title"
                  value=""
                  name="title"
                  onChange={handleInputChange}
                />
              </div>
              <div className="w-1/2">
                <label className="text-[#344054] font-['Plus_Jakarta_Sans'] text-sm font-medium leading-5">
                  Subject
                </label>
                <CustomSelect
                  data={subjects.map(item => ({
                    label: item.name,
                    value: item.id,
                  }))}
                  onChange={handleSubjectSelect}
                />
                {/* <Select
                  name="subject_exam"
                  id="subject_exam"
                  className="input-box"
                  options={subjects.map((subject, index) => ({
                    value: subject.id,
                    label: subject.name,
                  }))}
                  onChange={handleSubjectSelect}
                  placeholder="Select subject"
                /> */}
              </div>
            </div>
          </div>
        }
      />
    </div>
  );
}
